<template>
  <div class="agriculture-solution">
    <!-- Hero Section -->
    <section class="hero">
      <div class="container">
        <h1>智慧农业解决方案</h1>
        <p>打造现代化农业生产系统</p>
      </div>
    </section>

    <!-- Features Section -->
    <section class="features">
      <div class="container">
        <h2 class="section-title">核心功能</h2>
        <el-row :gutter="30">
          <el-col :xs="24" :sm="12" :md="6" v-for="(feature, index) in features" :key="index">
            <div class="feature-card">
              <i :class="feature.icon"></i>
              <h3>{{ feature.title }}</h3>
              <p>{{ feature.description }}</p>
            </div>
          </el-col>
        </el-row>
      </div>
    </section>

    <!-- Solution Details -->
    <section class="solution-details">
      <div class="container">
        <el-row :gutter="30">
          <el-col :xs="24" :md="12">
            <div class="solution-content">
              <h2>解决方案优势</h2>
              <ul>
                <li v-for="(advantage, index) in advantages" :key="index">
                  <i class="el-icon-check"></i>
                  {{ advantage }}
                </li>
              </ul>
            </div>
          </el-col>
          <el-col :xs="24" :md="12">
            <div class="solution-image">
              <img src="@/assets/images/agriculture-detail.jpg" alt="智慧农业解决方案">
            </div>
          </el-col>
        </el-row>
      </div>
    </section>

    <!-- Application Cases -->
    <section class="cases">
      <div class="container">
        <h2 class="section-title">应用场景</h2>
        <el-row :gutter="30">
          <el-col :xs="24" :sm="12" :md="8" v-for="(case_, index) in cases" :key="index">
            <div class="case-card">
              <div class="case-image">
                <img :src="case_.image" :alt="case_.title">
              </div>
              <div class="case-content">
                <h3>{{ case_.title }}</h3>
                <p>{{ case_.description }}</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </section>

    <!-- Contact Section -->
    <section class="contact">
      <div class="container">
        <h2>联系我们</h2>
        <p>了解更多智慧农业解决方案详情</p>
        <el-button type="primary" size="large" @click="contactUs">立即咨询</el-button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'AgricultureSolution',
  data() {
    return {
      features: [
        {
          icon: 'el-icon-monitor',
          title: '土壤监测',
          description: '实时监测土壤墒情、养分含量'
        },
        {
          icon: 'el-icon-data-line',
          title: '气象数据',
          description: '采集温度、湿度、光照等数据'
        },
        {
          icon: 'el-icon-water-cup',
          title: '灌溉控制',
          description: '智能灌溉系统，精准控制用水'
        },
        {
          icon: 'el-icon-warning',
          title: '病虫害防治',
          description: '智能识别病虫害，及时预警'
        }
      ],
      advantages: [
        '提高农作物产量，增加经济效益',
        '降低人工成本，提升生产效率',
        '节约水资源，实现精准灌溉',
        '减少农药使用，保障食品安全',
        '科学种植管理，提高品质'
      ],
      cases: [
        {
          image: require('@/assets/images/case7.jpg'),
          title: '智能温室大棚',
          description: '帮助某农业园区建设智能温室大棚'
        },
        {
          image: require('@/assets/images/case8.jpg'),
          title: '农田监测系统',
          description: '为某农场部署农田环境监测系统'
        },
        {
          image: require('@/assets/images/case9.jpg'),
          title: '智能灌溉系统',
          description: '协助某农业合作社建设智能灌溉系统'
        }
      ]
    }
  },
  methods: {
    contactUs() {
      this.$router.push('/contact')
    }
  }
}
</script>

<style lang="scss" scoped>
.agriculture-solution {
  .hero {
    background: linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url('~@/assets/images/agriculture-hero.jpg');
    background-size: cover;
    background-position: center;
    height: 400px;
    display: flex;
    align-items: center;
    color: #fff;
    text-align: center;
    
    .container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 20px;
      
      h1 {
        font-size: 48px;
        margin-bottom: 20px;
      }
      
      p {
        font-size: 24px;
      }
    }
  }
  
  .section-title {
    text-align: center;
    font-size: 36px;
    margin-bottom: 50px;
    color: #2c3e50;
  }
  
  .features {
    padding: 80px 0;
    background: #f8f9fa;
    
    .feature-card {
      text-align: center;
      padding: 30px;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      margin-bottom: 30px;
      
      i {
        font-size: 48px;
        color: #409EFF;
        margin-bottom: 20px;
      }
      
      h3 {
        font-size: 20px;
        margin-bottom: 15px;
        color: #2c3e50;
      }
      
      p {
        color: #666;
        line-height: 1.6;
      }
    }
  }
  
  .solution-details {
    padding: 80px 0;
    
    .solution-content {
      h2 {
        font-size: 32px;
        margin-bottom: 30px;
        color: #2c3e50;
      }
      
      ul {
        list-style: none;
        padding: 0;
        
        li {
          margin-bottom: 15px;
          color: #666;
          display: flex;
          align-items: center;
          
          i {
            color: #67C23A;
            margin-right: 10px;
          }
        }
      }
    }
    
    .solution-image {
      img {
        width: 100%;
        border-radius: 8px;
        box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      }
    }
  }
  
  .cases {
    padding: 80px 0;
    background: #f8f9fa;
    
    .case-card {
      background: #fff;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      margin-bottom: 30px;
      
      .case-image {
        height: 200px;
        overflow: hidden;
        
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s;
        }
      }
      
      &:hover {
        .case-image img {
          transform: scale(1.1);
        }
      }
      
      .case-content {
        padding: 20px;
        
        h3 {
          font-size: 20px;
          margin-bottom: 10px;
          color: #2c3e50;
        }
        
        p {
          color: #666;
          line-height: 1.6;
        }
      }
    }
  }
  
  .contact {
    padding: 80px 0;
    text-align: center;
    background: linear-gradient(135deg, #409EFF, #67C23A);
    color: #fff;
    
    h2 {
      font-size: 36px;
      margin-bottom: 20px;
    }
    
    p {
      font-size: 18px;
      margin-bottom: 30px;
    }
  }
}

@media screen and (max-width: 768px) {
  .agriculture-solution {
    .hero {
      height: 300px;
      
      .container {
        h1 {
          font-size: 32px;
        }
        
        p {
          font-size: 18px;
        }
      }
    }
    
    .solution-details {
      .solution-content {
        margin-bottom: 30px;
      }
    }
  }
}</style> 